import { useaxios } from "../../../utils/useaxios";
export default (category_name, category_start_code) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    initDispatch({ type: 'loadingTrue' });
    useaxios('category/create.php', { category_name, category_start_code }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        } else if (res.status == "ok") {
            setrecaller(recaller + 1);
        } else {
            alert('تکایە دڵنیابە لە داخڵکردنی زانیاری دروست');
            initDispatch({ type: 'loadingFalse' });
        }
        // setloading(false);
    });
}